import React, { useState } from 'react';
import { ConsumerModel } from '../../models';
import { getConsumer } from '../../utils';

export type FormItem = { [key: string]: any };

export interface SurPlusResultData {
	surplus?: number,
	salesPrice?: number,
	salesCosts: number,
	mortgage?: number
}

interface FormContextProps {
    form: FormItem;
    isLoading: boolean;
    data: SurPlusResultData | null;
		consumer: ConsumerModel;
    updateForm: (items: FormItem) => void;
    setIsLoading: (state: boolean) => void;
    updateData: (data: SurPlusResultData | null) => void;
}

export const FormContext = React.createContext<FormContextProps>({
    form: {},
    isLoading: false,
    data: null,
		consumer: getConsumer(),
    updateForm: (items: FormItem) => {},
    setIsLoading: (state: boolean) => {},
    updateData: (data: SurPlusResultData | null) => null,
});

export const FormProvider: React.FC = ({ children }) => {
    const [form, setForm] = useState({});
    const [isLoading, setIsLoading] = useState(false);
    //const [data, setData] = useState<SurPlusResultData | null>({ surplus: 10000, salesPrice: 20000});
    const [data, setData] = useState<SurPlusResultData | null>(null);
		const [consumer] = useState<ConsumerModel>(getConsumer());

    function updateForm(items: FormItem) {
        setForm({
            ...form,
            ...items,
        });
    }

    function updateData(info: SurPlusResultData | null) {
			(info) ? setData({ ...info }) : setData(null)
    }

    return (
        <FormContext.Provider
            value={{
                isLoading,
                form,
								data,
								consumer,
								updateForm,
								setIsLoading,
                updateData,
            }}>
            {children}
        </FormContext.Provider>
    );
};
